// extracted by mini-css-extract-plugin
module.exports = {"supper":"supperDealing_supper__yn_o_","content":"supperDealing_content__pumYe","select":"supperDealing_select__ns6H8","total":"supperDealing_total__ukHku"};